import { useMutation, useQuery } from "@tanstack/react-query";

import useAxios from "../common/hooks/useAxios";
import {
  GET_USER_PERMISSIONS_BY_ID,
  LIST_USER_PERMISSIONS,
  UPDATE_USER_PERMISSIONS,
} from "../userPermissions/api/userPermissions-api";
import { useCallback } from "react";

export const USER_PERMISSION_QUERIES = {
  listUserPermissions: "listUserPermissions",
};

const useUserPermissionsApi = (enabledApis = []) => {
  const axios = useAxios();

  const {
    data: userPermissions = [],
    isFetching: isUserPermissionsLoading,
    refetch: listUserPermissions,
  } = useQuery({
    queryKey: [USER_PERMISSION_QUERIES.listUserPermissions],
    queryFn: () => axios.get(LIST_USER_PERMISSIONS).then((res) => res.data),
    enabled: enabledApis.includes(USER_PERMISSION_QUERIES.listUserPermissions),
  });

  const {
    mutateAsync: updateUserPermission,
    isPending: isUpdatingUserPermission,
  } = useMutation({
    mutationFn: (data) =>
      axios
        .post(UPDATE_USER_PERMISSIONS(data.userId), data.data)
        .then((res) => res.data),
  });

  const getUserPermissionsById = useCallback(
    async (id) => {
      return await axios
        .get(GET_USER_PERMISSIONS_BY_ID(id))
        .then((res) => res.data);
    },
    [axios]
  );

  return {
    listUserPermissionsApi: {
      execute: listUserPermissions,
      isLoading: isUserPermissionsLoading,
      data: userPermissions,
    },
    getUserPermissionApi: {
      execute: getUserPermissionsById,
    },
    updateUserPermissionApi: {
      execute: updateUserPermission,
      isLoading: isUpdatingUserPermission,
    },
  };
};

export default useUserPermissionsApi;
